// extracted by mini-css-extract-plugin
export var button = "_lg-0";